export const formatSeoString = (str: string): string => {
  if (!str) return '';

  // Türkçe karakterleri değiştir
  const turkishChars: { [key: string]: string } = {
    'ı': 'i', 'İ': 'i',
    'ğ': 'g', 'Ğ': 'g',
    'ü': 'u', 'Ü': 'u',
    'ş': 's', 'Ş': 's',
    'ö': 'o', 'Ö': 'o',
    'ç': 'c', 'Ç': 'c'
  };

  // String'i küçük harfe çevir
  let result = str.toLowerCase();

  // Türkçe karakterleri değiştir
  Object.keys(turkishChars).forEach(char => {
    result = result.replace(new RegExp(char, 'g'), turkishChars[char]);
  });

  // Özel karakterleri ve boşlukları temizle
  result = result
    .replace(/[^a-z0-9\s-]/g, '') // Sadece harf, rakam, boşluk ve tire karakterlerini tut
    .replace(/\s+/g, '-') // Birden fazla boşluğu tire ile değiştir
    .replace(/-+/g, '-') // Birden fazla tireyi tek tireye dönüştür
    .replace(/^-+|-+$/g, ''); // Baştaki ve sondaki tireleri kaldır

  return result;
};

export function toSeoString(str: string): string {
  return str
    .toLowerCase()
    .replace(/ç/g, 'c')
    .replace(/ğ/g, 'g')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ş/g, 's')
    .replace(/ü/g, 'u')
    .replace(/Ç/g, 'c')
    .replace(/Ğ/g, 'g')
    .replace(/İ/g, 'i')
    .replace(/Ö/g, 'o')
    .replace(/Ş/g, 's')
    .replace(/Ü/g, 'u')
    .replace(/[^a-z0-9\-\s]/gi, '') // özel karakterleri sil
    .replace(/\s+/g, '-') // boşlukları - ile değiştir
    .replace(/-+/g, '-') // birden fazla -'yi teke indir
    .replace(/^-+|-+$/g, ''); // baştaki ve sondaki -'leri sil
}

/** Dosya adından uzantıyı kaldırır: "xxx.png" -> "xxx" */
export function fileNameWithoutExtension(fileName: string): string {
  if (!fileName || !String(fileName).trim()) return fileName ?? '';
  const s = String(fileName).trim();
  const lastDot = s.lastIndexOf('.');
  if (lastDot <= 0) return s;
  return s.slice(0, lastDot);
} 